///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, EventEmitter, Output } from '@angular/core';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { ActionsToolbarModeEnum } from '../../../generated/shared-types.model';
import { GtthAutoConnectCommand } from '../../logical-topology/engine/commands/design/auto-connect-command';
import { GtthNotificationsService } from '../../logical-topology/engine/notifications-service';
import { GtthExportService } from '../../../services/project/export.service';
import { TopologyLinkTypeEnum } from '../../../services/project-socket/dto/topology-types.model';
import { GtthProjectInfoViewService } from '../../../layouts/navbar/project-info-view.service';

@Component({
    selector: 'winde-step-los',
    templateUrl: './step-los.component.html',
    styleUrls: ['./los.scss', '../steps-toolbar.scss'],
    standalone: false
})
export class GtthStepLosComponent {
    @Output() stateChanged = new EventEmitter<any>();

    public supportedLineTypes = [
        {
            losType: TopologyLinkTypeEnum.NOT_CONFIRMED_LOS,
            type: ActionsToolbarModeEnum.NOT_CONFIRMED_LOS,
            class: 'no-confirmed-los'
        },
        {
            losType: TopologyLinkTypeEnum.CONFIRMED_LOS,
            type: ActionsToolbarModeEnum.CONFIRMED_LOS,
            class: 'confirmed-los'
        },
        {
            losType: TopologyLinkTypeEnum.NO_LOS,
            type: ActionsToolbarModeEnum.NO_LOS,
            class: 'no-los'
        },
        {
            losType: TopologyLinkTypeEnum.FIBER,
            type: ActionsToolbarModeEnum.FIBER,
            class: 'fiber'
        }
    ];

    constructor(
        public readonly historyService: GtthHistoryService,
        private readonly notificationService: GtthNotificationsService,
        private readonly exportService: GtthExportService,
        private readonly projectInfoViewService: GtthProjectInfoViewService
    ) {}

    autoconnect() {
        if (!this.historyService.logicalTopology.getTerminalStationsCount()) {
            this.notificationService.showError('No Locations found');
            return;
        }

        this.historyService.logicalTopology.autoConnectOptions.layerIndex = this.historyService.logicalTopology.activeLayerIdx;
        const autoConnectCommand = this.historyService.command(GtthAutoConnectCommand).create();
        this.historyService.doCommand(autoConnectCommand);
    }

    exportKmlFile() {
        if (this.historyService.logicalTopology.isTopologyEmpty()) {
            this.notificationService.showError('Could not export empty topology');
        } else {
            this.exportService.exportKmlFile();
        }
    }

    exportSites(fileExtension: string, includeLoses: boolean) {
        if (this.historyService.logicalTopology.isTopologyEmpty()) {
            this.notificationService.showError('Could not export from empty topology');
        } else {
            this.exportService.exportSites(this.projectInfoViewService.activeLayer, fileExtension, includeLoses);
        }
    }

    modeChanged(type: ActionsToolbarModeEnum) {
        this.stateChanged.emit({ type });
    }
}
